// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "message-card{margin:10px;padding:10px;border:1px solid #ccc;border-radius:5px;background-color:#fff;font-size:16px!important;text-align:left;transition:all .3s;background:rgb(var(--v-theme-error))}.message-card span{font-size:20px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
